import { commonServiceSlice } from "../common/commanServiceSlice";
import { fetchServices } from "./serviceThunk";

const serviceSlice = commonServiceSlice({
  name: "services",
  thunk: fetchServices,
});

export default serviceSlice.reducer;
